import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_rj5w53dbnq: FaireBrandEntity = {
  token: "b_rj5w53dbnq",
  type: "brand",
  name: "Sacred Sparkle Jewelry and Accessories for Women",
  avatarUrl:
    "https://cdn.faire.com/fastly/6d2a6efa945bee71be8e88157d7fbe97bdc413b967df22bc94eeff31e8222bee.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1c0064ae023e3adc8cb8c9c20cbd4c05f711a50692621273715524b4eea9eb56.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6d2a6efa945bee71be8e88157d7fbe97bdc413b967df22bc94eeff31e8222bee.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1c0064ae023e3adc8cb8c9c20cbd4c05f711a50692621273715524b4eea9eb56.png",
  location: "San Antonio, TX, USA",
  minimumOrderDollars: 40,
  rating: 4.6,
  reviewCount: 5,
  isInsider: true,
  description:
    "✨ Sacred Sparkle Jewelry ✨\nFaith-Inspired Wholesale Jewelry with Meaning\n\nTexas-based & women-owned, Sacred Sparkle Jewelry blends faith, fashion, and purpose into affordable pieces boutiques love to stock. From dainty cross necklaces to minimalist scripture bracelets, our collections are designed to inspire hope while fitting effortlessly into everyday style.\n\nPerfect for boutiques, gift shops, tourist shops, and Christian retailers looking for meaningful jewelry that sells with heart.\n\nEvery piece proudly honors Jesus — and a portion of profits helps rescue women and children from sexual slavery.We give so they have a safe place to heal and become who they were meant to be.\n\nBeautiful jewelry. Faith-filled purpose. Lives transformed. 🤍\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:55.518Z",
    importedBy: "entity-db-cli",
  },
};
